import React, { useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { server } from "..";
import Loader from "./Loader";
import ToolWorkspace from "../components/ToolWorkspace";

const EquationSolver = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [disable, setDisable] = useState(false);
  const [output, setOutput] = useState("");
  const [loader, setLoader] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file || null);
  };

  const removeImage = () => setSelectedImage(null);

  const handlesubmit = async () => {
    if (!selectedImage) {
      toast.error("No file selected");
      return;
    }

    setDisable(true);
    setLoader(true);
    const formData = new FormData();
    formData.append("imagesolve", selectedImage);

    try {
      const { data } = await axios.post(`${server}/tools/solve`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });
      setOutput(data.trying);
      toast.success("Done!");
    } catch (e) {
      toast.error(`Error ${e}`);
    } finally {
      setDisable(false);
      setLoader(false);
    }
  };

  return (
    <ToolWorkspace
      label="Math solver"
      title="Equation Solver"
      subtitle="Upload a photo of a problem and get a clear solution."
      sampleHref="/Testing/formula_test.png"
      sampleName="formula_test.png"
    >
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="flex flex-col gap-3">
          <input
            type="file"
            accept="image/*"
            id="formula-file"
            onChange={handleFileChange}
            className="hidden"
          />
          <button
            type="button"
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-brand-forest/12 bg-brand-surface px-4 py-3 font-display text-sm font-semibold text-brand-forest transition hover:border-brand-teal/40 hover:bg-brand-soft/70"
            onClick={() => document.getElementById("formula-file").click()}
          >
            <i className="ri-image-add-line text-lg text-brand-teal-dark" />
            Upload image
          </button>

          <div className="min-h-[180px] flex-1">
            {selectedImage ? (
              <div className="relative overflow-hidden rounded-xl border border-brand-forest/10">
                <img
                  src={URL.createObjectURL(selectedImage)}
                  className="max-h-[50vh] w-full object-contain"
                  alt="Preview"
                />
                <button
                  type="button"
                  className="absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center rounded-full bg-white text-red-600 shadow-sm transition hover:bg-red-50"
                  onClick={removeImage}
                  aria-label="Remove image"
                >
                  <i className="ri-close-line text-lg" />
                </button>
              </div>
            ) : (
              <div className="flex h-full min-h-[180px] items-center justify-center rounded-xl border border-dashed border-brand-forest/15 bg-brand-surface/70 px-4 text-center font-display text-sm text-brand-muted">
                Image preview will appear here
              </div>
            )}
          </div>

          <button
            type="button"
            onClick={handlesubmit}
            disabled={disable}
            className="btn w-full disabled:cursor-not-allowed disabled:opacity-70"
          >
            {disable ? "Solving..." : "Solve image"}
          </button>
        </div>

        <div className="flex min-h-[280px] items-stretch">
          {loader ? (
            <div className="flex w-full items-center justify-center rounded-xl border border-brand-forest/10 bg-brand-surface">
              <Loader />
            </div>
          ) : (
            <textarea
              disabled
              className="min-h-[280px] w-full resize-y rounded-xl border border-brand-forest/12 bg-brand-surface/50 px-4 py-3 font-display text-[0.95rem] text-brand-forest outline-none placeholder:text-brand-muted/55"
              placeholder="Solved equation will show here"
              value={output}
            />
          )}
        </div>
      </div>
    </ToolWorkspace>
  );
};

export default EquationSolver;
